// What counts as a company having a logo, decided once.
//
// Its own module, beside CompanyLogo.tsx, for the same reason button-classes.ts sits beside
// Button.tsx: a file that exports both a component and a plain function breaks Fast Refresh. The
// component draws; this decides.

import { imageDataUrl } from "@/lib/image-data-url";

export interface CompanyLogoValue {
  mimeType?: string | null;
  content?: string | null;
}

/**
 * The data: URI for a stored logo, or null when there is none to render.
 *
 * A data: URI AND NEVER A URL. The BFF's CSP admits images from self, data: and blob: only, and the
 * blob store's own origin is not among them, so a src pointing at it would fail silently and leave
 * a broken frame where the logo should be. That is why the bytes travel base64 inside the GraphQL
 * response at all.
 *
 * BOTH HALVES HAVE TO BE PRESENT. genesis pairs the two columns at the database level
 * (ck_company_logo), so half a logo should be unreachable, but a half-built `data:` URI renders as a
 * broken image on a page anybody may read. So it is never built, and the caller falls back to the
 * monogram exactly as it would for a company that uploaded nothing. This guards the type, not a
 * state that is expected to occur.
 */
export function companyLogoSrc(logo: CompanyLogoValue | null | undefined): string | null {
  return imageDataUrl(logo);
}
